import { useState } from "react";

interface PlotSectionProps {
  plot: string[];
}

export default function PlotSection({ plot }: PlotSectionProps) {
  const [expanded, setExpanded] = useState(false);
  const visible = expanded ? plot : plot.slice(0, 1);

  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
      <h2 className="mb-4 flex items-center gap-2 text-lg font-bold text-foreground-950 md:text-xl">
        <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-100 text-primary-700">
          <i className="ri-file-text-line" />
        </span>
        剧情简介
      </h2>
      <div className="relative">
        <div className="space-y-4 text-sm leading-relaxed text-foreground-700 md:text-base">
          {visible.map((paragraph) => (
            <p key={paragraph.slice(0, 16)}>{paragraph}</p>
          ))}
        </div>
        {!expanded && plot.length > 1 && (
          <div className="pointer-events-none absolute bottom-0 h-16 w-full bg-gradient-to-t from-background-50 to-transparent" />
        )}
      </div>
      {plot.length > 1 && (
        <button
          type="button"
          onClick={() => setExpanded((v) => !v)}
          className="mt-4 flex items-center gap-1 rounded-md text-sm font-medium text-primary-600 transition-colors hover:text-primary-700 cursor-pointer whitespace-nowrap"
        >
          {expanded ? "收起剧情" : "展开全部剧情"}
          <i className={expanded ? "ri-arrow-up-s-line text-lg" : "ri-arrow-down-s-line text-lg"} />
        </button>
      )}
    </section>
  );
}